import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import moment from "moment";
import {
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  FormControl,
} from "@material-ui/core";
import { Row, Col, Image, Button, Modal } from "react-bootstrap";
import SocketContext from "../../../../function/SocketContext";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  create_chat_vendor_user,
  get_single_chat_vendor_user,
} from "../../../../store/actions/notificationAction/notificationActions";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  UPDATE_CHAT_INFO,
  UPDATE_MULTIPLE_CHAT_INFO,
} from "../../../../store/types";

export const ChatWindowScreen = (props) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [state, setState] = useState({
    restaurantID: "",
    singleUserData: {},
    actionBy: "",
    messageText: "",
    hasSetData: false,
  });

  const openNav = (e) => {
    const token = props.auth.user.accessToken;
    let vendor_id = props?.vendorAccess?.vendor_id || props?.data?.vendor_id;
    let diner_id = props.data && props.data._id;
    let queryObj = {};
    if (props.text === "seating") {
      queryObj = { vendor: vendor_id, diner: diner_id };
    }
    if (props.text === "order") {
      queryObj = { vendor: vendor_id, order: diner_id };
    }
    if (props.text === "event") {
      queryObj = { vendor: vendor_id, event: diner_id };
    }
    if (props.text === "expRequest") {
      queryObj = { vendor: vendor_id, expRequest: diner_id };
    }
    props.get_single_chat_vendor_user(queryObj, token);
    setShow(true);
  };

  const closeNav = (e) => {
    setState({
      ...state,
      restaurantID: "",
      singleUserData: {},
      messageText: "",
      hasSetData: false,
      singleChatUser: [],
    });
    setSingleChatUser([]);
    dispatch({ type: UPDATE_CHAT_INFO, payload: "reset" });
    setShow(false);
  };

  useEffect(() => {
    setState({
      ...state,
      singleUserData: props.data,
      actionBy: props.text,
    });
  }, [props.onboarding]);

  const [singleChatUser, setSingleChatUser] = useState([]);
  useEffect(() => {
    setSingleChatUser(props.singleUserChat && props.singleUserChat.messages);
  }, [props.singleUserChat]);

  useEffect(() => {
    props.socket.service("chat").on("created", async (data) => {
      dispatch({ type: UPDATE_CHAT_INFO, payload: data });
      dispatch({ type: UPDATE_MULTIPLE_CHAT_INFO, payload: data });
    });
    let interval = setInterval(() => { }, 3000);
    return () => clearInterval(interval);
  }, []);

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmitMessage = (e) => {
    const token = props.auth.user.accessToken;
    const formData = {
      user:
        props?.userTicketChatAction === "USER_TICKET"
          ? props?.data?.user_id?._id
          : props?.data?.user_id ? props?.data?.user_id : props?.data?.userId,
      vendor: props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id,
      restaurant: props.onboarding._id,
      message: state.messageText,
      sentBy: "VENDOR",
    };
    if (state.actionBy === "seating") {
      formData.diner = props.data._id;
    } else if (state.actionBy === "expRequest") {
      formData.expRequest = props.data._id;
    } else if (state.actionBy === "order") {
      formData.order = props.data._id;
    }
    props.create_chat_vendor_user(formData, token, (data) => onSuccess(data));
  };

  const onSuccess = (data) => {
    setState({
      ...state,
      messageText: "",
    });
    // if (props.singleUserChat._id === undefined) {
    //   onSingleChatGetClick();
    // }
    dispatch({ type: UPDATE_CHAT_INFO, payload: data });
  };

  const onSingleChatGetClick = () => {
    const token = props.auth.user.accessToken;
    let vendor_id =
      props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id;
    let diner_id = props.data._id;
    props.get_single_chat_vendor_user(
      { vendor: vendor_id, diner: diner_id },
      token
    );
  };

  // console.log(state.singleUserData, "*********88");
  return (
    <React.Fragment>
      {/* <div class="container"> */}

      {props.text === "superadmin" ? (
        <div className="enIconBtn mr-3" onClick={(e) => openNav(e)}>
          <Image
            src={require("../../../../assets/images/UserManagement/eye.svg")}
            alt="Chat"
            title="Chat"
            fluid
          />
        </div>
      ) : (
        <Button
          variant="link"
          className="enIconBtn mr-3"
          onClick={(e) => openNav(e)}
        >
          <Image
            src={require("../../../../assets/images/UserManagement/forum.svg")}
            alt="Chat"
            title="Chat"
            fluid
          />
        </Button>
      )}
      <Modal
        show={show}
        onHide={(e) => closeNav(e)}
        dialogClassName="modal-90w chat-modal-main"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
        className="demo"
        style={{ zIndex: "1060" }}
      >
        <Modal.Header closeButton>
          <div className="f14-700" style={{ paddingLeft: "1rem" }}>
            {state.actionBy === "seating"
              ? "Seating"
              : state.actionBy === "order"
                ? "Order"
                : state.actionBy === "expRequest"
                  ? "Experience"
                  : "Event"}{" "}
            Chat
          </div>
        </Modal.Header>
        <Modal.Body id="onboarding-scrollbar" className="p-0">
          <ChatWindowMain
            dinerData={state && state.singleUserData}
            state={state}
            singleChatUser={singleChatUser}
            onChange={onChange}
            onSubmitMessage={onSubmitMessage}
            authentication={props.auth}
            onboardingData={props.onboarding}
            allChatData={props.data}
          />
        </Modal.Body>
      </Modal>
      {/* </div> */}
    </React.Fragment>
  );
};

ChatWindowScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  onboarding: state.onboarding.restaurantDetails,
  singleUserChat: state.notifications.chatInfo,
  auth: state.auth,
  errors: state.errors.errors,
});

const ChatWindow = (props) => (
  <SocketContext.Consumer>
    {(socket) => <ChatWindowScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
  create_chat_vendor_user,
  get_single_chat_vendor_user,
})(withRouter(ChatWindow));

export const ChatWindowMain = (props) => {
  // console.log(props, "*");
  return (
    <React.Fragment>
      <div>
        <div style={{ backgroundColor: "#F8F8F8" }} className="p-3">
          <div className="d-flex align-items-center">
            <div style={{ width: "15%" }}>
              <Image
                src={
                  props.allChatData &&
                    props.allChatData.user_details &&
                    props.allChatData.user_details.profile_photo !== undefined &&
                    props.allChatData &&
                    props.allChatData.user_details &&
                    props.allChatData.user_details.profile_photo.length > 0
                    ? props.allChatData &&
                    props.allChatData.user_details &&
                    props.allChatData.user_details.profile_photo
                    : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                }
                fluid
                alt="Profile Picture"
                title="Profile Picture"
                className="rounded-circle"
              />
            </div>
            <div className="pl-2">
              <div className="f12-500">
                {props?.allChatData?.user_details?.name || props?.allChatData?.userDetails?.name}
              </div>
              <div className="f10-400" style={{ color: "#757575" }}>
                #
                {props.state.actionBy === "seating"
                  ? props.allChatData && props.allChatData.diner_id
                  : props.state.actionBy === "order"
                    ? props?.allChatData?.order_id
                    : props.state.actionBy === "expRequest"
                      ? props?.allChatData?.requestId
                      : props.dinerData && props.dinerData.event_request_id}
              </div>
            </div>
          </div>
        </div>
        <div
          className="mt-3"
        //  style={{ minHeight: "462px" }}
        >
          {!isEmpty(props.singleChatUser) &&
            props.singleChatUser.map((chat, index) => {
              return (
                <React.Fragment key={index}>
                  {chat.sentBy === "VENDOR" ? (
                    <RightSideMsg
                      content={chat.message}
                      source={chat.sentBy === "VENDOR" ? "You" : "User"}
                      date={moment(chat.date).format("hh:mm A, Do MMM YYYY")}
                    />
                  ) : (
                    <LeftSideMsg
                      content={chat.message}
                      source={chat.sentBy === "VENDOR" ? "You" : "User"}
                      date={moment(chat.date).format("hh:mm A, Do MMM YYYY")}
                    />
                  )}
                </React.Fragment>
              );
            })}
        </div>
        <div
          style={{ position: "absolute", bottom: "0" }}
          className="w-100 mb-4"
        >
          {/* <hr /> */}
          <div className="border-top border-bottom p-3">
            <FormControl className={"w-100"} variant="outlined">
              <Row>
                <Col xs={12}>
                  <InputLabel htmlFor="outlined-Mobile" className="pl-4">
                    Write your message
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    name="messageText"
                    value={props.state.messageText}
                    onChange={props.onChange}
                    id="outlined-msg"
                    className="w-100"
                    endAdornment={
                      <InputAdornment position="end">
                        {props.authentication.secondary_loader ? (
                          <Loader
                            type="ThreeDots"
                            color="#00BFFF"
                            height={25}
                            width={25}
                          />
                        ) : (
                          <IconButton
                            edge="end"
                            onClick={props.onSubmitMessage}
                          >
                            <span
                              className="chat-button-box-button"
                              style={{
                                background: "#EE3A23",
                                color: "white",
                                borderRadius: "5px",
                                padding: "5px",
                                fontSize: "20px",
                                cursor: "pointer",
                              }}
                            >
                              <i
                                className="font-awesome-flag-size fa fa-paper-plane-o"
                                aria-hidden="true"
                              ></i>
                            </span>
                            {/* <SendIcon /> */}
                          </IconButton>
                        )}
                      </InputAdornment>
                    }
                    labelWidth={155}
                  />
                </Col>
                {/* <Col md={2}>
                  {props.authentication.secondary_loader ? (
                    <Loader
                      type="ThreeDots"
                      color="#00BFFF"
                      height={25}
                      width={25}
                    />
                  ) : (
                    ""
                  )}
                </Col> */}
              </Row>
            </FormControl>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const RightSideMsg = (props) => {
  return (
    <React.Fragment>
      <>
        <div className="row mt-2 w-100">
          <Col xs={2} className="p-0"></Col>
          <Col xs={10} className="p-0">
            <div
              style={{
                backgroundColor: "#FFB116",
                borderRadius: "5px 5px 0px 5px",
              }}
              className=" p-2"
            >
              {/* <div className="f11-400">{props.title}</div> */}
              <div className="f11-400 text-white">{props.content}</div>
            </div>
            {props.date && (
              <div className="f10-700 mt-1" align="right">
                <span style={{ color: "#9E9E9E" }} className="f10-400">
                  {props.date}
                </span>
                | {props.source}
              </div>
            )}
          </Col>
        </div>
      </>
    </React.Fragment>
  );
};

const LeftSideMsg = (props) => {
  return (
    <React.Fragment>
      <>
        <div className="row mt-2 w-100">
          <Col xs={10} className="p-0 ml-3">
            <div
              style={{
                backgroundColor:
                  props.source === "Admin" ? "#42B5FC" : "#E6E6E6",
                borderRadius: "5px 5px 5px 0px",
              }}
              className=" p-2"
            >
              {/* <div className="f11-400">{props.title}</div> */}
              <div className="f11-400">{props.content}</div>
            </div>
            {props.date && (
              <div className="f10-700 mt-1" align="left">
                <span style={{ color: "#9E9E9E" }} className="f10-400">
                  {props.date}
                </span>
                | {props.source}
              </div>
            )}
          </Col>
          <Col xs={2} className="p-0"></Col>
        </div>
      </>
    </React.Fragment>
  );
};
